import { memo, useEffect, useRef } from 'react';
import '@/assets/styles/components/registration-agreement.styles.scss';
import { AgreementProps } from './registration-agreement.types.ts';

const RegistrationAgreement = memo(({ pdfUrl, onAccept, isOpen, isLoading }: AgreementProps) => {
	const scrollPosition = useRef(0);

	useEffect(() => {
		if (isOpen) {
			scrollPosition.current = window.scrollY;
			document.body.style.position = 'fixed';
			document.body.style.top = `-${scrollPosition.current}px`;
			document.body.style.width = '100%';
		}

		return () => {
			document.body.style.position = '';
			document.body.style.top = '';
			document.body.style.width = '';
			window.scrollTo(0, scrollPosition.current);
		};
	}, [isOpen]);

	if (!isOpen) return null;

	return (
		<div className="agreement">
			<div className="agreement-container">
				<div className="agreement-content">
					<iframe
						src={`${pdfUrl}#toolbar=0`}
						className="agreement-pdf"
						title="Sözleşme"
					/>
				</div>

				<div className="agreement-footer">
					<button
						onClick={onAccept}
						disabled={isLoading}
						className="agreement-button">
						Okudum, kabul ediyorum
						<i className="icons-arrow-right arrow" />
					</button>
				</div>
			</div>
		</div>
	);
});

export default RegistrationAgreement;
